import { createSlice } from '@reduxjs/toolkit'
import { logoutUser } from '../middlewares/logoutMiddleware'

const initialState = {
    impersonated: false,
    developerMode: false,
}

const authPersistSlice = createSlice({
    name: 'authPersist',
    initialState,
    reducers: {
        setImpersonated: (state, action) => {
            state.impersonated = action.payload
        },
        setDeveloperMode: (state, action) => {
            state.developerMode = action.payload
        },
    },
    extraReducers: builder => builder.addCase(logoutUser, () => initialState),
})

export const authPersistActions = authPersistSlice.actions

export default authPersistSlice.reducer
